<ngx-editor #ngxEditor [(ngModel)]="editorText" (ngModelChange)="editorTextChanged($event)" [ngStyle]="extraNgxEditorStyles"></ngx-editor>
